// AI-CONTEXT: See docs/features/impact-in-beeld-fase3.md

/**
 * Verbindingsstatus van de transactie-koppeling: 'connected' zodra er ooit een
 * transactie is binnengekomen. Een API-sleutel alleen is géén verbinding —
 * pas de eerste echte transactie bewijst dat het kassasysteem echt praat.
 *
 * @param {{LastTransactionAt?: *}|null|undefined} liveStats - Het ImpactLiveStats-doc van de tenant
 * @returns {'connected'|'not-connected'}
 */
const deriveConnectionStatus = (liveStats) =>
    liveStats && liveStats.LastTransactionAt ? 'connected' : 'not-connected'

export { deriveConnectionStatus }
